import { ReactComponent as LightningGradientCircle } from 'assets/icons/lightning-gradient-circle.svg';

export default LightningGradientCircle;
